import styled from 'styled-components';

const StyledTransactionsTabContainer = styled.div`
  position: relative;
`;

const StyledTableContainer = styled.div`
  display: flex;
  overflow-x: hidden;
  margin-top: 24px;
  margin-bottom: 54px;
  position: relative;
  min-height: ${props => props.fullHeight === 'true' ? '100vh' : 'unset'};

  .expense-details-panel {
    padding-left: 24px;

    & > footer {
      width: calc(100% - 24px);
      right: 0;
      left: unset;
    }

    & > .ant-tabs {
      & > .ant-tabs-content-holder {
        max-height: calc(100vh - (66px + 48px + 42px));
        height: 100vh;
        overflow: auto;
      }
    }
  }
`;

const StyledTable = styled.div`
`;

export {
  StyledTransactionsTabContainer,
  StyledTableContainer,
  StyledTable
};
